import * as types from "./types";
import axios from "axios";
import { push } from "connected-react-router";

export const getAllProjects = () => async (dispatch) => {
  dispatch({
    type: types.GET_ALL_PROJECTS_WAIT,
  });
  try {
    const { data } = await axios.get(`/api/v1/project/`);
    dispatch({
      type: types.GET_ALL_PROJECTS_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_ALL_PROJECTS_ERROR,
      payload: e,
    });
  }
};

export const getProject = (projectId) => async (dispatch) => {
  dispatch({
    type: types.GET_PROJECT_WAIT,
  });
  try {
    const { data } = await axios.get(`/api/v1/project/${projectId}/`);
    dispatch({
      type: types.GET_PROJECT_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_PROJECT_ERROR,
      payload: e,
    });
  }
};

export const createProject = (title, image) => async (dispatch) => {
  dispatch({
    type: types.CREATE_PROJECT_WAIT,
  });
  try {
    const formData = new FormData();

    if (image === null) {
      formData.append("title", title);
    } else {
      formData.append("file", image, image.name);
      formData.append("title", title);
    }

    const { data } = await axios.post(`/api/v1/project/`, formData);
    dispatch({
      type: types.CREATE_PROJECT_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${data.id}`));
  } catch (e) {
    dispatch({
      type: types.CREATE_PROJECT_ERROR,
      payload: e,
    });
  }
};

export const patchProject =
  (projectId, title, comments) => async (dispatch) => {
    dispatch({
      type: types.PATCH_PROJECT_WAIT,
    });
    try {
      const { data } = await axios.patch(`/api/v1/project/${projectId}/`, {
        id: projectId,
        title: title,
        comments: comments,
      });
      dispatch({
        type: types.PATCH_PROJECT_SUCCESS,
        payload: data,
      });
    } catch (e) {
      dispatch({
        type: types.PATCH_PROJECT_ERROR,
        payload: e,
      });
    }
  };

export const deleteProject = (projectId) => async (dispatch) => {
  dispatch({
    type: types.DELETE_PROJECT_WAIT,
  });
  try {
    const { data } = await axios.delete(`/api/v1/project/${projectId}/`);
    dispatch({
      type: types.DELETE_PROJECT_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/`));
  } catch (e) {
    dispatch({
      type: types.DELETE_PROJECT_ERROR,
      payload: e,
    });
  }
};

// CHART
export const getDetailChart = (projectId, chartId) => async (dispatch) => {
  dispatch({
    type: types.GET_DETAIL_CHART_WAIT,
  });
  try {
    const { data } = await axios.get(
      `/api/v1/project/${projectId}/chart/${chartId}/`
    );
    dispatch({
      type: types.GET_DETAIL_CHART_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_DETAIL_CHART_ERROR,
      payload: e,
    });
  }
};

export const updateChart =
  (projectId, chartId, payload) => async (dispatch) => {
    dispatch({
      type: types.UPDATE_CHART_WAIT,
    });
    try {
      const { data } = await axios.patch(
        `/api/v1/project/${projectId}/update_chart/${chartId}/`,
        payload
      );
      dispatch({
        type: types.UPDATE_CHART_SUCCESS,
        payload: data,
      });
    } catch (err) {
      dispatch({
        type: types.UPDATE_CHART_ERROR,
        payload: err,
      });
    }
  };

// BuyerMap
export const getAllBuyerMap = (projectId) => async (dispatch) => {
  dispatch({
    type: types.GET_ALL_BUYERMAP_WAIT,
  });
  try {
    const { data } = await axios.get(`/api/v1/project/${projectId}/buyermap/`);
    dispatch({
      type: types.GET_ALL_BUYERMAP_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_ALL_BUYERMAP_ERROR,
      payload: e,
    });
  }
};

export const createBuyerMap = (title, projectId) => async (dispatch) => {
  dispatch({
    type: types.CREATE_CHART_WAIT,
  });
  try {
    const { data } = await axios.post(
      `/api/v1/project/${projectId}/create_chart/`,
      {
        project: projectId,
        title: title,
        type: "BuyerMap",
        data: [
          {
            id: 0,
            title: "Приобретение",
            simplicity: "black",
            productivity: "green",
          },
          {
            id: 1,
            title: "Доставка",
            convenience: "black",
          },
          {
            id: 2,
            title: "Использование",
            funAndImage: "red",
          },
          {
            id: 3,
            title: "Дополнительные продукты и услуги",
            riskReduction: "black",
          },
          {
            id: 4,
            title: "Обслуживание",
          },
          {
            id: 5,
            title: "Утилизация",
            environmentalFriendliness: "black",
          },
        ],
        insights: [
          { insights: "Черные отметки - боли клиента" },
          {
            insights:
              "Красные отметки - фокус Алого океана на удовлетворении потребностей клиентов",
          },
          {
            insights:
              "Голубые отметки - фокус Голубого океана в удовлетворении потребностей клиентов",
          },
        ],
      }
    );
    dispatch({
      type: types.CREATE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/buyermap/${data.id}/`));
  } catch (e) {
    dispatch({
      type: types.CREATE_CHART_ERROR,
      payload: e,
    });
  }
};

export const deleteBuyerMap = (projectId, chartId) => async (dispatch) => {
  dispatch({
    type: types.DELETE_CHART_WAIT,
  });
  try {
    const { data } = await axios.delete(
      `/api/v1/project/${projectId}/delete_chart/${chartId}/`
    );
    dispatch({
      type: types.DELETE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/buyermap/`));
  } catch (e) {
    dispatch({
      type: types.DELETE_CHART_ERROR,
      payload: e,
    });
  }
};

// StrategyMap
export const getAllStrategyMap = (projectId) => async (dispatch) => {
  dispatch({
    type: types.GET_ALL_STRATEGYMAP_WAIT,
  });
  try {
    const { data } = await axios.get(
      `/api/v1/project/${projectId}/strategymap/`
    );
    dispatch({
      type: types.GET_ALL_STRATEGYMAP_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_ALL_STRATEGYMAP_ERROR,
      payload: e,
    });
  }
};

export const createStrategyMap = (title, projectId) => async (dispatch) => {
  dispatch({
    type: types.CREATE_CHART_WAIT,
  });
  try {
    const { data } = await axios.post(
      `/api/v1/project/${projectId}/create_chart/`,
      {
        project: projectId,
        title: title,
        type: "StrategyMap",
        data: {
          data: [
            { title: "Цена", "Компания 1": 71, "Компания 2": 50 },
            { title: "Фактор 2", "Компания 1": 82, "Компания 2": 20 },
            { title: "Фактор 3", "Компания 1": 82, "Компания 2": 30 },
            { title: "Фактор 4", "Компания 1": 79, "Компания 2": 50 },
            { title: "Фактор 5", "Компания 1": 71, "Компания 2": 58 },
            { title: "Фактор 6", "Компания 1": 52, "Компания 2": 40 },
            { title: "Фактор 7", "Компания 1": 50, "Компания 2": 60 },
          ],
          series: ["Компания 1", "Компания 2"],
          colors: ["#03a9f4", "#7e57c2", "#ec407a", "#4caf50", "#ffeb3b"],
        },
      }
    );
    dispatch({
      type: types.CREATE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/strategymap/${data.id}/`));
  } catch (e) {
    dispatch({
      type: types.CREATE_CHART_ERROR,
      payload: e,
    });
  }
};

export const deleteStrategyMap = (projectId, chartId) => async (dispatch) => {
  dispatch({
    type: types.DELETE_CHART_WAIT,
  });
  try {
    const { data } = await axios.delete(
      `/api/v1/project/${projectId}/delete_chart/${chartId}/`
    );
    dispatch({
      type: types.DELETE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/strategymap/`));
  } catch (e) {
    dispatch({
      type: types.DELETE_CHART_ERROR,
      payload: e,
    });
  }
};

// NonCustomers
export const getAllNonCustomers = (projectId) => async (dispatch) => {
  dispatch({
    type: types.GET_ALL_NONCUSTOMERS_WAIT,
  });
  try {
    const { data } = await axios.get(
      `/api/v1/project/${projectId}/noncustomers/`
    );
    dispatch({
      type: types.GET_ALL_NONCUSTOMERS_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_ALL_NONCUSTOMERS_ERROR,
      payload: e,
    });
  }
};

export const createNonCustomers = (title, projectId) => async (dispatch) => {
  dispatch({
    type: types.CREATE_CHART_WAIT,
  });
  try {
    const { data } = await axios.post(
      `/api/v1/project/${projectId}/create_chart/`,
      {
        project: projectId,
        title: title,
        type: "NonCustomers",
        data: [],
      }
    );
    dispatch({
      type: types.CREATE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/noncustomers/${data.id}/`));
  } catch (e) {
    dispatch({
      type: types.CREATE_CHART_ERROR,
      payload: e,
    });
  }
};

export const deleteNonCustomers = (projectId, chartId) => async (dispatch) => {
  dispatch({
    type: types.DELETE_CHART_WAIT,
  });
  try {
    const { data } = await axios.delete(
      `/api/v1/project/${projectId}/delete_chart/${chartId}/`
    );
    dispatch({
      type: types.DELETE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/noncustomers/`));
  } catch (e) {
    dispatch({
      type: types.DELETE_CHART_ERROR,
      payload: e,
    });
  }
};

// ERRC
export const getAllERRC = (projectId) => async (dispatch) => {
  dispatch({
    type: types.GET_ALL_ERRC_WAIT,
  });
  try {
    const { data } = await axios.get(`/api/v1/project/${projectId}/errc/`);
    dispatch({
      type: types.GET_ALL_ERRC_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_ALL_ERRC_ERROR,
      payload: e,
    });
  }
};

export const createERRC = (title, projectId) => async (dispatch) => {
  dispatch({
    type: types.CREATE_CHART_WAIT,
  });
  try {
    const { data } = await axios.post(
      `/api/v1/project/${projectId}/create_chart/`,
      {
        project: projectId,
        title: title,
        type: "ERRC",
        data: [],
      }
    );
    dispatch({
      type: types.CREATE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/errc/${data.id}/`));
  } catch (e) {
    dispatch({
      type: types.CREATE_CHART_ERROR,
      payload: e,
    });
  }
};

export const deleteERRC = (projectId, chartId) => async (dispatch) => {
  dispatch({
    type: types.DELETE_CHART_WAIT,
  });
  try {
    const { data } = await axios.delete(
      `/api/v1/project/${projectId}/delete_chart/${chartId}/`
    );
    dispatch({
      type: types.DELETE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/errc/`));
  } catch (e) {
    dispatch({
      type: types.DELETE_CHART_ERROR,
      payload: e,
    });
  }
};

// ToBeStrategyMap
export const getAllToBeStrategyMap = (projectId) => async (dispatch) => {
  dispatch({
    type: types.GET_ALL_TOBESTRATEGYMAP_WAIT,
  });
  try {
    const { data } = await axios.get(
      `/api/v1/project/${projectId}/tobestrategymap/`
    );
    dispatch({
      type: types.GET_ALL_TOBESTRATEGYMAP_SUCCESS,
      payload: data,
    });
  } catch (e) {
    dispatch({
      type: types.GET_ALL_TOBESTRATEGYMAP_ERROR,
      payload: e,
    });
  }
};

export const createToBeStrategyMap = (title, projectId) => async (dispatch) => {
  dispatch({
    type: types.CREATE_CHART_WAIT,
  });
  try {
    const { data } = await axios.post(
      `/api/v1/project/${projectId}/create_chart/`,
      {
        project: projectId,
        title: title,
        type: "ToBeStrategyMap",
        data: {
          data: [
            { title: "Цена", "Компания 1": 71, "Компания 2": 50 },
            { title: "Фактор 2", "Компания 1": 82, "Компания 2": 20 },
            { title: "Фактор 3", "Компания 1": 82, "Компания 2": 30 },
            { title: "Фактор 4", "Компания 1": 79, "Компания 2": 50 },
            { title: "Фактор 5", "Компания 1": 71, "Компания 2": 58 },
            { title: "Фактор 6", "Компания 1": 52, "Компания 2": 40 },
            { title: "Фактор 7", "Компания 1": 50, "Компания 2": 60 },
          ],
          series: ["Компания 1", "Компания 2"],
          colors: ["#03a9f4", "#7e57c2", "#ec407a", "#4caf50", "#ffeb3b"],
        },
      }
    );
    dispatch({
      type: types.CREATE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/tobestrategymap/${data.id}/`));
  } catch (e) {
    dispatch({
      type: types.CREATE_CHART_ERROR,
      payload: e,
    });
  }
};

export const deletChart = (projectId, chartId) => async (dispatch) => {
  dispatch({
    type: types.DELETE_CHART_WAIT,
  });
  try {
    const { data } = await axios.delete(
      `/api/v1/project/${projectId}/delete_chart/${chartId}/`
    );
    dispatch({
      type: types.DELETE_CHART_SUCCESS,
      payload: data,
    });
    dispatch(push(`/project/${projectId}/`));
  } catch (e) {
    dispatch({
      type: types.DELETE_CHART_ERROR,
      payload: e,
    });
  }
};
